import React, {Component} from "react";
import {Card, CardBody, Row} from "reactstrap";

import GameIcon from "../../components/game-icon/game-icon";
import Hr from "../../components/hr/hr";

class PlayerFavoriteGameCard extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        const {favorite_game_data} = this.props;

        return <div className="mp-0">
            <Card className="shadow player-dashboard-card-height">
                <CardBody className="mx-1 p-1">
                    <Row className="mp-0">
                        <h6>Favorite Game<Hr/></h6>
                    </Row>
                    {favorite_game_data &&
                    <div className="mp-0">
                        <GameIcon game={favorite_game_data} gameIconStyle={{width: 90}}/>
                        <p className="mt-1 small secondary-color">{favorite_game_data.game_name}</p>
                    </div>
                    }
                    {!favorite_game_data &&
                    <h6 className="text-secondary">No Activities Played</h6>
                    }
                </CardBody>
            </Card>
        </div>
    };
}

export default PlayerFavoriteGameCard;






// WEBPACK FOOTER //
// ./src/components/components/player-favorite-game-card/player-favorite-game-card.js